export default __webpack_public_path__ + "static/media/debate_29.e564e89e.JPG";